// src/hooks/useDocumentTitle.js
import { useEffect } from "react";
import { useLang } from "../context/LanguageContext";

const SUFFIX = "Kaida Beauty Studio";

/**
 * Sets the browser tab title, and keeps it in sync when the language changes.
 *
 * Pass a translation key, or `{ text }` for something already resolved —
 * a product name, for instance, which comes from Firestore rather than the
 * dictionary.
 */
export default function useDocumentTitle(keyOrOptions) {
  const { t, lang } = useLang();

  useEffect(() => {
    const isText = typeof keyOrOptions === "object" && keyOrOptions !== null;
    const raw = isText
      ? keyOrOptions.text
      : keyOrOptions
        ? t(keyOrOptions)
        : "";
    const label = (raw || "").trim();

    // The homepage shows the brand alone; every other page prefixes itself.
    document.title = label ? `${label} — ${SUFFIX}` : SUFFIX;
  }, [keyOrOptions, t, lang]);
}
